import findIndex from 'lodash/findIndex';
import cloneDeep from 'lodash/cloneDeep';
import Tour from 'app/shared/model/Tour';

const getTourMode = ({
    isCommunity,
    floorPlanIndex = null,
    unitIndex = null,
}) => {
    let mode = isCommunity ? 'amenity' : 'singleFamily';

    if (floorPlanIndex !== null) {
        mode = 'floorplan';
    }
    if (unitIndex !== null) {
        mode = 'unit';
    }
    return mode;
};

const getModelId = ({
    floorPlanIndex = null,
    unitIndex = null,
    formData: { floorplans, units },
}) => {
    const floorPlan = floorPlanIndex !== null && floorplans[floorPlanIndex];
    // Unit tour without floor plan
    if (floorPlanIndex === null && unitIndex !== null) {
        return units[unitIndex].unitId;
    }

    // Unit tour with floor plan
    if (floorPlanIndex !== null && unitIndex !== null) {
        const unit = floorPlan && floorPlan.units[unitIndex];
        return unit ? unit.unitId : null;
    }
    return floorPlan ? floorPlan.floorPlanId : null;
};

const updateTour = ({
    floorPlanIndex = null,
    formData: { units, floorplans, tours },
    tourToUpdate,
    tourType = 'amenity',
    previousVrModelId = '',
    unitIndex = null,
    updateFormData,
}) => {
    // Unit tour without floor plan
    if (floorPlanIndex === null && unitIndex !== null) {
        const newUnits = cloneDeep(units);
        newUnits[unitIndex].tour = tourToUpdate;
        updateFormData({ units: newUnits });
    } else if (floorPlanIndex !== null) {
        const newFloorplans = cloneDeep(floorplans);

        // Unit tour with floor plan
        if (unitIndex !== null) {
            newFloorplans[floorPlanIndex].units[unitIndex].tour = tourToUpdate;
        // Floor plan tour
        } else {
            newFloorplans[floorPlanIndex].tour = tourToUpdate;
        }
        updateFormData({ floorplans: newFloorplans });
    } else {
        const newTours = cloneDeep(tours);
        if (tourType === 'amenity') {
            const currentTourIndex = previousVrModelId === ''
                ? -1 :
                findIndex(newTours, tour => tour.id === previousVrModelId);
            // Deleted a tour
            if (tourToUpdate.id === '' && currentTourIndex > -1) {
                newTours.splice(currentTourIndex, 1);
                const hasEmptyTour = newTours.some(tour => tour.id === '');
                // If the last one is being deleted, add a new tour
                if (!hasEmptyTour && newTours.length < 6) {
                    newTours.push(new Tour());
                }
            } else if (tourToUpdate.id !== '') {
                // Added a tour
                if (currentTourIndex < 0) {
                    newTours.splice(newTours.length - 1, 0, tourToUpdate);
                    // Don't let people add more than 6 amenity tours
                    if (newTours.length > 6) {
                        newTours.splice(newTours.length - 1, 1);
                    }
                // Updated a tour
                } else {
                    newTours.splice(currentTourIndex, 1, tourToUpdate);
                }
            }
        } else {
            newTours[0] = tourToUpdate;
        }
        updateFormData({ tours: newTours });
    }
};

export {
    getModelId,
    getTourMode,
    updateTour,
};
